/*
 * @param _value The value to check for exhaustiveness.
 */
export function ensureExhaustive(_value: never): never;
export function ensureExhaustive<T>(_value: never, defaultValue: T): T;
export function ensureExhaustive<T>(_value: never, defaultValue?: T): T {
  console.warn(
    `There is a type not being handled properly, please view the stack trace for more info. [${JSON.stringify(
      _value
    )}]`
  );
  return defaultValue as T;
}
export function typedKeys<T extends object>(obj: T): (keyof T)[] {
  return Object.keys(obj) as (keyof T)[];
}

export function typedEntries<T extends object>(
  obj: T
): [keyof T, T[keyof T]][] {
  return Object.entries(obj) as [keyof T, T[keyof T]][];
}

/**
 * Maps the values of an object to a new object using a provided function.
 * @param obj The object to map over.
 * @param fn The function to apply to each value.
 * @returns A new object with the same keys as the input object, and the values transformed by the provided function.
 */
export function mapObject<T extends object, U>(
  obj: T,
  fn: (value: T[keyof T], key: keyof T) => U
): { [K in keyof T]: U } {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, fn(value, key as keyof T)])
  ) as { [K in keyof T]: U };
}
